module.exports = __webpack_public_path__ + "img/youtube_ab5401ef27647994c707c1f0fa40730f.longcache.png";